module.exports = __webpack_public_path__ + "images/GSE_Promo_Video_rev6_1080p.mp4";